<template>
    <v-app id="inspire">
        <v-navigation-drawer 
            v-model="drawer"
            color="white"
            app
            v-if="checkITS"
        >
            <Navigation></Navigation>
        </v-navigation-drawer>
        <v-app-bar 
          app
          color="#004236"
        >
          <v-app-bar-nav-icon @click="drawer = !drawer" v-if="checkITS" color="white"></v-app-bar-nav-icon>
          <v-toolbar-title><span>Fund Balances</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon href="https://www.kings.uwo.ca/its/kings-employee-centre/fund-balances-how-to-use/" v-bind="attrs" v-on="on" large target="_blank">
                <v-icon color="white">mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Help Documentation</span>
          </v-tooltip>
        </v-app-bar>
        <v-main>
            <br />
            <router-view></router-view>
        </v-main>
    </v-app>
</template>
  
  <script>
  import auth from "../../js/auth.js"
  import Navigation from '../../components/Navigation.vue'
  
  export default {
    name: 'DefaultHome',
    components: {
      Navigation
    },
    data() {
      return {
        drawer: null
      }
    },
    computed: {
      checkITS(){
        return auth.is_ITS();
      }
    }
  }
  </script>
  
  <style scoped>
  span{
    color: white;
  }
  </style>